import React from 'react';
import { Helmet } from 'react-helmet-async';
import { COMPANY_INFO, SITE_URL } from '../../seoConfig';

// LocalBusiness Schema - für Startseite und Kontaktseite
export const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "HomeAndConstructionBusiness"],
    "@id": `${SITE_URL}/#business`,
    "name": COMPANY_INFO.name,
    "legalName": COMPANY_INFO.legalName,
    "url": COMPANY_INFO.url,
    "logo": COMPANY_INFO.logo,
    "image": [COMPANY_INFO.image],
    "telephone": COMPANY_INFO.telephone,
    "email": COMPANY_INFO.email,
    "foundingDate": COMPANY_INFO.foundingDate,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": COMPANY_INFO.address.streetAddress,
      "postalCode": COMPANY_INFO.address.postalCode,
      "addressLocality": COMPANY_INFO.address.addressLocality,
      "addressCountry": COMPANY_INFO.address.addressCountry
    },
    "areaServed": COMPANY_INFO.areaServed.map(area => ({
      "@type": "AdministrativeArea",
      "name": area
    })),
    "description": "Altbausanierung in Stuttgart & Region: Fassadensanierung, Dachsanierung, Innensanierung und energetische Sanierung.",
    "knowsAbout": COMPANY_INFO.knowsAbout,
    "priceRange": "$$"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

// Service Schema - für einzelne Leistungsseiten
export const ServiceSchema = ({ service }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${SITE_URL}/leistungen/${service.slug}#service`,
    "name": service.name,
    "serviceType": service.serviceType,
    "provider": {
      "@type": "LocalBusiness",
      "@id": `${SITE_URL}/#business`
    },
    "areaServed": {
      "@type": "AdministrativeArea",
      "name": "Stuttgart"
    },
    "description": service.shortDescription,
    "url": `${SITE_URL}/leistungen/${service.slug}`,
    "image": `${SITE_URL}${service.image}`
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

// Breadcrumb Schema
export const BreadcrumbSchema = ({ items }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

// FAQ Schema
export const FAQSchema = ({ faqs }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

// WebSite Schema - für Startseite
export const WebSiteSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    "url": SITE_URL,
    "name": COMPANY_INFO.name,
    "description": "Altbausanierung in Stuttgart & Region",
    "publisher": {
      "@id": `${SITE_URL}/#business`
    },
    "inLanguage": "de-DE"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
